import React from "react";
import {
  Box,
  Dialog,
  Typography,
  IconButton,
  CircularProgress,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import Icons from "@/assets";

const StyledButton = styled(Button)(({ theme }) => ({
  fontWeight: 500,
  fontSize: "3.88vw",
  lineHeight: "130%",
  textAlign: "center",
  borderRadius: "30px",
  padding: theme.spacing(1.5, 4),
  backgroundImage: "linear-gradient(180deg, #9D79F4 0%, #7747FB 100%)",
  color: "#fff",
  "&:hover": {
    backgroundImage: "linear-gradient(180deg, #9D79F4 0%, #7747FB 100%)",
    boxShadow: "0 4px 12px rgba(157, 121, 244, 0.4)",
  },
  "&.Mui-disabled": {
    background: "#ccc",
    color: "#999",
  },
}));

interface VerifyEmailModalProps {
  open: boolean;
  onClose: () => void;
  email: string;
  onResend: () => void;
  isLoading: boolean;
}

const VerifyEmailModal: React.FC<VerifyEmailModalProps> = ({
  open,
  onClose,
  email,
  onResend,
  isLoading,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          padding: "32px",
          width: "95%",
          position: "relative",
          textAlign: "center",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: "2%",
          top: "2%",
          color: "grey.500",
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        sx={{
          mx: "auto",
          height: { xs: "29.13vw", sm: 125 },
          width: { xs: "29.13vw", sm: 125 },
        }}
      >
        <img
          src={Icons.Resend}
          alt="Resend"
          style={{ width: "100%", height: "100%" }}
        />
      </Box>

      <Typography
        variant="h5"
        sx={{
          fontSize: { xs: "3.88vw", md: "16px" },
          fontWeight: 700,
          mt: { xs: "3.16vw", sm: 13 },
          mb: { xs: "2.43vw", sm: 10 },
          color: "#191919",
        }}
      >
        Please verify to Login
      </Typography>

      <Typography
        variant="body1"
        sx={{
          fontSize: { xs: "3.4vw", md: "14px" },
          color: "#626262",
          mb: { xs: "5.34vw", sm: 22 },
        }}
      >
        Click <strong style={{ color: "#313131" }}>Resend Link</strong> to send
        a new link to <strong style={{ color: "#313131" }}>{email}</strong>.
      </Typography>

      <StyledButton
        fullWidth
        onClick={onResend}
        disabled={isLoading}
        sx={{ m: 0 }}
      >
        {isLoading ? (
          <CircularProgress size={24} color="inherit" />
        ) : (
          "Resend Link"
        )}
      </StyledButton>
    </Dialog>
  );
};

export default VerifyEmailModal;
